export const rules ={
        name: [
        { required: true, message: "请输入规则名称", trigger: "blur" },
      ],
      reward_amount: [
        { required: true, message: "请输入赠送金额", trigger: "change" },
      ],
      min_amount: [
        { required: true, message: "最小触发范围", trigger: "change" },
      ],
      max_amount: [
        { required: true, message: "最大触发范围", trigger: "change" },
      ],
      start_time: [
        { required: true, message: "开始时间", trigger: "change" },
      ],
      end_time: [
        { required: true, message: "结束时间", trigger: "change" },
      ],

     
    }